import {
  CREATE_SMARTLINK_PARAMETER,
  DELETE_SMARTLINK_PARAMETER,
  EDIT_SMARTLINK_PARAMETER,
  RECEIVE_SMARTLINK_PARAMETERS,
  REQUEST_SMARTLINK_PARAMETER,
} from '@sophocles/entities/SmartlinkParameter/smartlinkParameterActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_SMARTLINK_PARAMETERS: // Read
      return state.merge(action.smartlinkParameters);
    case DELETE_SMARTLINK_PARAMETER: // Delete
      return state.delete(action.smartlinkParameter.toString());
    case EDIT_SMARTLINK_PARAMETER: // Update
    case CREATE_SMARTLINK_PARAMETER: // Create
    case REQUEST_SMARTLINK_PARAMETER:
    default:
      return state;
  }
}

export function smartlinkParameterReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_SMARTLINK_PARAMETER:
    case DELETE_SMARTLINK_PARAMETER:
    case RECEIVE_SMARTLINK_PARAMETERS:
    case EDIT_SMARTLINK_PARAMETER:
    case REQUEST_SMARTLINK_PARAMETER:
      return getState(state, action);
    default:
      return state;
  }
}
